<template>
  <div v-if="videoUrl" class="message-video-wrap">
    <video
      class="message-video"
      :controls="false"
      playsinline
      preload="metadata"
      :src="videoUrl"
      webkit-playsinline
      x5-playsinline
    ></video>
    <!-- <div v-if="!videoStarted" class="message-video-poster" @click="startPlay"> -->
    <div class="message-video-poster" @click="startPlay">
      <span class="message-video-poster__play">
        <i class="icon-play-fill t-iconfont"></i>
      </span>
    </div>
    <!-- 预览 -->
    <VideoPreview
      v-if="videoStarted"
      :index="0"
      :list="[videoUrl]"
      @close="videoStarted = false"
    ></VideoPreview>
  </div>
</template>

<script setup>
import { computed, ref, defineAsyncComponent } from 'vue'

const VideoPreview = defineAsyncComponent(
  () => import(/* webpackChunkName: "file-video-preview" */ '@/components/files/file-video-preview')
)

const props = defineProps({
  message: {
    type: Object,
    default: () => ({
      url: ''
    })
  }
})

const videoStarted = ref(false)

const videoUrl = computed(() => props.message.url || '')

const startPlay = () => {
  videoStarted.value = true
}
</script>

<style lang="scss" scoped>
.message-video-wrap {
  position: relative;
  width: 240px;
  max-width: 100%;
  overflow: hidden;
  background: #111;
  border-radius: 12px;

  .message-video {
    display: block;
    width: 240px;
    max-width: 100%;
    background: #111;
    border-radius: 12px;
  }

  .message-video-poster {
    position: absolute;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    // background: linear-gradient(180deg, rgba(0, 0, 0, 0.12) 0%, rgba(0, 0, 0, 0.4) 100%);
    // background-color: #111;

    &::after {
      position: absolute;
      inset: 0;
      content: '';
      background: linear-gradient(180deg, rgba(0, 0, 0, 0.08) 0%, rgba(0, 0, 0, 0.36) 100%);
    }

    &__play {
      position: relative;
      z-index: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 52px;
      height: 52px;
      color: #fff;
      background: rgba(0, 0, 0, 0.35);
      border: 1px solid rgba(255, 255, 255, 0.24);
      border-radius: 50%;

      i {
        font-size: 28px;
      }
    }
  }
}
</style>
